var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGallery = function SvgGallery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 37,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#262929",
    strokeWidth: 3,
    d: "M3.5 5.5A1.5 1.5 0 0 1 5 4h26a1.5 1.5 0 0 1 1.5 1.5v26A1.5 1.5 0 0 1 31 33H5a1.5 1.5 0 0 1-1.5-1.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#262929",
    strokeWidth: 2,
    d: "m4 32.5 7.584-11.376a.5.5 0 0 1 .832 0l2.825 4.238a1 1 0 0 0 1.613.07l6.365-7.956a1 1 0 0 1 1.562 0L32 26.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12.5,
    r: 3,
    stroke: "#262929",
    strokeWidth: 2
  })));
};
export default SvgGallery;